import React, { useEffect, useRef, useState } from 'react';
import { useI18n } from '../i18n';
import PhoneMock from './PhoneMock';
import { Check } from 'lucide-react';

export default function Features() {
  const { t } = useI18n();
  const phoneRef = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver((entries) => { entries.forEach((e) => { if (e.isIntersecting) setVisible(true); }); }, { threshold: 0.4 });
    if (phoneRef.current) obs.observe(phoneRef.current);
    return () => obs.disconnect();
  }, []);
  return (
    <section id="features" className="md:min-h-screen" style={{ padding: '44px 24px', position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center' }}>
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(700px 400px at 20% 30%, rgba(59,116,255,0.1), transparent 62%)', pointerEvents: 'none' }} />
      <div style={{ position: 'relative', width: '100%', maxWidth: 1160, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 48, alignItems: 'center' }}>
        <div>
          <p style={{ fontSize: 13, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--hm-gold)', margin: 0 }}>{t.features.eyebrow}</p>
          <h2 className="font-sora" style={{ margin: '10px 0 0', fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 800, letterSpacing: '-0.02em', lineHeight: 1.1 }}>{t.features.title}</h2>
          <p style={{ margin: '14px 0 0', fontSize: 16, color: 'var(--color-neutral-400)', lineHeight: 1.6, maxWidth: '48ch' }}>{t.features.subtitle}</p>
          <div style={{ marginTop: 28, display: 'grid', gap: 16 }}>
            {t.features.items.map((f) => (
              <div key={f.title} style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                <span style={{ flex: '0 0 auto', marginTop: 2, width: 26, height: 26, borderRadius: 8, background: 'color-mix(in srgb, var(--hm-gold) 14%, transparent)', border: '1px solid color-mix(in srgb, var(--hm-gold) 30%, transparent)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Check size={15} color="var(--hm-gold)" /></span>
                <div><div style={{ fontSize: 16, fontWeight: 600 }}>{f.title}</div><div style={{ fontSize: 14, color: 'var(--color-neutral-400)', lineHeight: 1.5 }}>{f.text}</div></div>
              </div>
            ))}
          </div>
        </div>
        <div className="phone-stage-3d" style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
          <div style={{ position: 'absolute', width: 380, height: 380, borderRadius: '50%', background: 'radial-gradient(circle, rgba(232,194,106,0.16), transparent 65%)', filter: 'blur(20px)' }} />
          <div ref={phoneRef} className={`phone-3d${visible ? ' is-visible' : ''}`}><PhoneMock width={340} /></div>
        </div>
      </div>
    </section>
  );
}
